module.exports = __webpack_public_path__ + "resources/img/img_yb_kr.1d94c075c2acaf7fc867b5094f5cbe55.png";